import { LIST_CDN } from 'shared/config'

export const checkCDN = (url?: string) => {
  if (!url) return false

  return LIST_CDN.some((value) => {
    return url.includes(value)
  })
}
